import { FC } from 'react';
import MainLayout from 'components/main-layout/MainLayout';

const Screen: FC = () => {
  return <MainLayout title="Добавяне на пакет с документи">създаване</MainLayout>;
};

export default Screen;
